import { cn } from '@/lib/utils';
import type { ModalTema } from './types';

interface SegmentedOption<T extends string | number> {
  value: T;
  label: string;
}

interface SegmentedControlProps<T extends string | number> {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  tema: ModalTema;
  disabled?: boolean;
  'aria-label'?: string;
}

const ATIVO_POR_TEMA: Record<ModalTema, string> = {
  azul: 'bg-primary text-white shadow-cta',
  verde: 'bg-tertiary text-on-tertiary shadow-cta',
};

// Segmentado genérico usado tanto p/ "Mensal | Anual" (modo Padrão, azul)
// quanto "1 ano | 2 anos | 3 anos" (modo Enterprise, verde).
export function SegmentedControl<T extends string | number>({
  options,
  value,
  onChange,
  tema,
  disabled,
  'aria-label': ariaLabel,
}: SegmentedControlProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className="inline-flex items-center gap-1 rounded-lg border border-border bg-muted p-1"
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={String(opt.value)}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className={cn(
              'rounded-md px-3 py-1.5 text-sm font-medium transition-colors disabled:opacity-50',
              active ? ATIVO_POR_TEMA[tema] : 'text-text-secondary hover:text-text-title'
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
